import { useAppBanner } from "./useAppBanner";
import AppBannerContent from "./AppBannerContent";
import classNames from "classnames";

const AppBanner = () => {
  const { showAppDownload, isAndroid, isClosed, openDownload, closeBanner } =
    useAppBanner();

  return (
    <div className={classNames(isAndroid && !isClosed ? "block" : "hidden")}>
      <AppBannerContent
        showAppDownload={showAppDownload}
        onOpen={openDownload}
        onClose={closeBanner}
      />
    </div>
  );
};

export default AppBanner;
